import { useEffect } from 'react';

import { CALENDAR, KPI, METADATA, store } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { _navigate } from './helpers';
import * as luxon from 'luxon';

const ENV = (import.meta as any).env;

export const SiteOverviewResolver = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const metadata = useSelector((state: any) => state.metadata);

  async function siteOverviewInit() {
    let _site: any = null;

    if (!params.id && (metadata?.entities as any)?.site?.length > 0) {
      _site = (metadata?.entities as any)?.site?.[0];
    } else if (params.id && (metadata?.entities as any)?.site?.length > 0) {
      _site = (metadata?.entities as any)?.site?.find(
        (site: any) => site.siteId === params.id
      );
    }

    if (!_site) {
      return;
    }

    dispatch(
      METADATA.SetSelectedEntity({
        selectedEntity: _site,
        id: _site?.siteId,
        entityType: pathSegment,
      } as any)
    );
  }

  // FLEXO-6114: capture the member-of-origin (site clicked from a member page),
  // store it as an ephemeral nav-context and strip `fromMember` from the URL so
  // it is used only for this navigation. Own effect keyed on `params.id` so it
  // does not re-fire (and reset the context) when entities change. Loads without
  // it reset the context to null.
  useEffect(() => {
    const sp = new URLSearchParams(window?.location?.search || '');
    const fromMember = sp.get('fromMember');
    dispatch(METADATA.SetNavContextMember(fromMember || null) as any);
    if (fromMember) {
      sp.delete('fromMember');
      const q = sp.toString();
      const newUrl =
        window.location.pathname + (q ? `?${q}` : '') + window.location.hash;
      window.history.replaceState(window.history.state, '', newUrl);
    }
  }, [params.id]);

  useEffect(() => {
    siteOverviewInit();
  }, [params.id, metadata?.entities]);

  return <></>;
};

export function navigateToSite(context, siteID: string) {
  const dispatch = store.dispatch;
  const location = window.location;
  const pathSegment = location.pathname.split('/')[2];

  // FLEXO-6114: when navigating to a site FROM a member page, carry the
  // member-of-origin so the site page keeps the member the user drilled in from
  // (a site's `memberId` can be a shared/other member). The site's OWN
  // community is resolved from its changelog, so no fromCommunity is needed.
  // Consumed once and stripped from the URL by SiteOverviewResolver.
  const sp = new URLSearchParams(window?.location?.search || '');
  const currentSegment = location.pathname.split('/')[1];
  if (currentSegment === 'member' && pathSegment) {
    sp.set('fromMember', pathSegment);
  }
  const q = sp.toString();
  const queryParams = q ? `?${q}` : '';

  dispatch(METADATA.SetPrevSelectedEntityId(pathSegment as any));

  dispatch(METADATA.SetSelectedSiteId(siteID as any));

  dispatch(KPI.ResetKpiFields());

  if (ENV?.VITE_APP_IS_WEB === 'true' && context === 'site') {
    // const D = luxon.DateTime.now().startOf('day').toJSDate();
    // const D2 = luxon.DateTime.now().plus({ days: 1 }).startOf('day').toJSDate();
    // dispatch(
    //   CALENDAR.setHiveDate({
    //     date: [D, D2],
    //     timeSet: 'day',
    //     setQueryParams: false,
    //   } as any)
    // );
  }

  _navigate(`/${context}/${siteID}${queryParams}`);
}
